"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function () { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function (o, m, k, k2) {
    if (k2 === undefined)
        k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function (o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function (o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function (o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o)
                if (Object.prototype.hasOwnProperty.call(o, k))
                    ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule)
            return mod;
        var result = {};
        if (mod != null)
            for (var k = ownKeys(mod), i = 0; i < k.length; i++)
                if (k[i] !== "default")
                    __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const debounce_1 = __importDefault(require("debounce"));
const filters_styles_1 = require("../../filters.styles");
const localization_1 = require("../../../../../../localization");
const TextInput = ({ onOptionChange, value, disabled = false }) => {
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const [inputValue, setInputValue] = (0, react_1.useState)(value);
    const handleChange = (0, react_1.useMemo)(() => (0, debounce_1.default)(onOptionChange, 300), [onOptionChange]);
    (0, react_1.useEffect)(() => {
        setInputValue(value);
    }, [value]);
    const handleInputChange = ({ target: { value } }) => {
        setInputValue(value);
        handleChange(value);
    };
    return (react_1.default.createElement(filters_styles_1.StyledInput, { variant: 'outlined', value: inputValue, placeholder: t({ key: 'VALUE' }), onChange: handleInputChange, disabled: disabled }));
};
exports.TextInput = TextInput;
exports.default = exports.TextInput;
